;(function ($) {
  $(document).ready(function () {
    var baseUrl = $("[data-publication-url]").attr("data-publication-url")

    // Infinite Scroll
    var scroll = new window.SOMAR.InfiniteScroll()

    $(".js-publication-categories-select").multiselect({
      includeSelectAllOption: true,
      buttonContainer: '<div class="btn-group d-lg-none"/>',
    })

    $(".js-publication-categories-select").on("change", function (ev) {
      var categories = $(this).val()
      var url = baseUrl

      if (categories.length > 0) {
        if (window.location.href.indexOf("archive") !== -1) {
          url = window.location.href.replace(/\/$/, "")
          url += "/" + categories.join("+")
          url = url.replace(/\s+/g, "-").toLowerCase()

          window.location = url
        } else {
          url += "/category/" + categories.join("+")
          url = url.replace(/\s+/g, "-").toLowerCase()

          window.location = url
        }
      } else {
        window.location = url
      }
    })
  })
})(jQuery)
